    function convertCSVToJson(csvData) {
      const lines = csvData.trim().split('\n');
      const headers = lines[0].split(',');
      const jsonData = [];

      for (let i = 1; i < lines.length; i++) {
        const line = lines[i].split(',');
        const entry = {};
        for (let j = 0; j < headers.length; j++) {
          entry[headers[j].trim().replace('"', '')] = line[j];
        }
        jsonData.push(entry);
      }

      return jsonData;
    }
